export default "__VITE_ASSET__ZFIzliMc__"